// Wrapper for pickatime

class TimePicker {
	constructor(el, options) {
		this.el = el;
		this.showMeridian = window.TIME_FORMAT !== '1';

		$(this.el).timepicker({
			template: false,
			minuteStep: 1,
			showMeridian: this.showMeridian,
			defaultTime: false,
			...options,
		});
	}
}

module.exports = TimePicker;
